<template>
  <v-container
    :class="($vuetify.breakpoint.smAndDown ? regular ? 'regular-14' : 'bold-16' : regular ? 'regular-18' : 'bold-24') + ' my-container pa-5'"
    :style="$vuetify.breakpoint.smAndDown ? 'min-height: 52px;' : 'min-height: 72px;'"
  >
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  props: { regular: Boolean }
};
</script>

<style scoped>
.my-container {
  align-items: center;
  border-radius: 4px;
  display: flex;
}
</style>
